import styles from "./Sidebar.module.scss"

import React, { useEffect, useState } from "react"

import {
  useSelectedVod,
  useSetSelectedVod,
  useVodPlayer,
  useVods,
} from "vod/contexts"

import FileList from "./FileList"
import Messages from "./Messages"

export default function Sidebar() {
  const vods = useVods()
  const vodPlayer = useVodPlayer()
  const selectedVod = useSelectedVod()
  const setSelectedVod = useSetSelectedVod()

  const [isContinueMessage, setIsContinueMessage] = useState<boolean>(true)

  useEffect(() => {
    if (!vods || !vodPlayer || !selectedVod) return

    const evtEnded = function () {
      let position = vods.findIndex((vod) => vod.id === selectedVod.id)
      position++

      if (position >= vods.length) return

      setIsContinueMessage(true)

      setSelectedVod(vods[position])
    }

    vodPlayer.on("ended", evtEnded)

    return () => {
      vodPlayer.off!("ended", evtEnded)
    }
  }, [selectedVod, vods, vodPlayer, setSelectedVod])

  return (
    <div className={`contB ${styles.newContB}`}>
      <FileList setIsContinueMessage={setIsContinueMessage} />
      <Messages isContinueMessage={isContinueMessage} />
    </div>
  )
}
